import React from "react";
import Icon from "../Icon";

import styles from "./LinkButton.module.scss";

const LinkButton = ({
  children = null,
  danger: isDanger,
  stickLeft: isStickLeft,
  icon,
  isInvisible = false,
  iconClassName,
  title,
  ...rest
}) =>
  !isInvisible ? (
    <button
      {...rest}
      className={`${styles.base} ${isDanger ? styles.danger : ""} ${
        isStickLeft ? styles.stickLeft : ""
      } ${rest.className ? rest.className : ""}`}
      type="button"
      title={title}
    >
      {icon && <Icon type={icon} className={iconClassName} />}
      {children}
    </button>
  ) : null;

export default LinkButton;
